/* eslint-disable @typescript-eslint/no-unused-vars */
import { memo, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import PageNav from '../PageNav/PageNav'
import { useUserInfo } from '@/hooks/useUserInfo'
import { sessionStore } from '@/utils/storage'
import './index.less'
const Home = (props: any) => {
  const { fetchUserInfo, loading } = useUserInfo()
  useEffect(() => {
    fetchUserInfo()
    // ppt 步骤判断
    if (['/createPPT'].includes(location.pathname)) {
      return
    }
    if (['/surePPTCatalog'].includes(location.pathname)) {
      const data: any = sessionStore.get('createPPTData', [])
      if (!data || !data.outLine) {
        props.history.push('/createPPT')
        return
      }
      return
    }
    if (['/selectPPTTheme'].includes(location.pathname)) {
      const data: any = sessionStore.get('createPPTData', [])
      if (!data || !data.theme || !data.theme.id) {
        props.history.push('/createPPT')
        return
      }
      return
    }
    if (['/resulePPT'].includes(location.pathname)) {
      const data: any = sessionStore.get('createPPTData', [])
      if (!data || !data.selectPageInfo || !data.selectPageInfo.thumbnail) {
        props.history.push('/createPPT')
        return
      }
      return
    }
    // 降重
    if (['/reduce/6', '/reduce/7'].includes(location.pathname)) {
      return
    }
    if (['/reduceSelect/6', '/reduceSelect/7'].includes(location.pathname)) {
      const data: any = sessionStore.get('reduceData', [])
      if (data?.fileList?.length || data?.reportList?.length) {
        return
      }
      props.history.push('/reduce/' + location.pathname.slice(-1))
      return
    }
    if (['/reduceResult/6', '/reduceResult/7'].includes(location.pathname)) {
      // const data: any = sessionStore.get('reduceData', [])
      // if (data?.fileList?.length || data?.reportList?.length) {
      //   return
      // }
      // props.history.push('/reduce/6')
      return
    }
    // 排版
    if (['/articleLayout'].includes(location.pathname)) {
      return
    }
    if (['/selectTemplate'].includes(location.pathname)) {
      return
    }
    if (['/layoutResult'].includes(location.pathname)) {
      return
    }
    // 正文步骤判断
    const data: any = sessionStore.get('stepData', [])
    if (location.pathname != '/') {
      if (!data || !data.steps || !data.steps.length) {
        props.history.push('/')
        return
      }
    }
    if (location.pathname === '/body') {
      if (!data.steps[3] || data.steps[3].pathname != '/body') {
        props.history.push('/')
        return
      }
    }
    if (location.pathname.indexOf('/catalog') > -1) {
      if (!data.steps[3]) {
        props.history.push('/')
        return
      }
    }
    if (location.pathname.indexOf('/references') > -1) {
      if (!data.steps[2]) {
        props.history.push('/')
        return
      }
    }
    if (location.pathname.indexOf('/major') > -1) {
      if (!data.steps[1]) {
        props.history.push('/')
        return
      }
    }
    if (location.pathname.indexOf('/plans') > -1) {
      if (!data.steps[1]) {
        props.history.push('/')
        return
      }
    }
  }, [])
  return (
    <main>
      {loading ? null : (
        <>
          <PageNav></PageNav>
          {props.children}
        </>
      )}
    </main>
  )
}

export default memo(withRouter(Home))
